import './styles/app.scss';
import React, { useContext } from 'react';
import { AppContext } from '@thd-nucleus/app-render';
import { Route, ScrollToTop, Routes } from '@thd-olt-component-react/router';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { Metadata } from '@thd-olt-component-react/metadata';
import { Error } from './pages';
import { getRoutes } from './routes';
import { LeftNavigation } from './pages/shared/LeftNavigation/LeftNavigation';
import { QuoteRefresh } from '@thd-olt-component-react/quote-refresh';

export const App = () => {
  const { instance } = useContext<any>(AppContext);
  const { currentRouteName, currentRouteComponent } = instance.router;
  const routes = getRoutes(currentRouteName, currentRouteComponent);

  return (
    <>
      <ErrorBoundary name="meta-data">
        <Metadata title="The Home Depot" />
      </ErrorBoundary>
      <ErrorBoundary name="scroll-to-top">
        <ScrollToTop />
      </ErrorBoundary>
      <ErrorBoundary name="quote-refresh">
        <QuoteRefresh />
      </ErrorBoundary>
      <div className="grid isBound">
        <div className="sui-grid md:sui-grid-cols-12 sui-grid-cols-1 sui-w-screen">
          <ErrorBoundary name="left-navigation">
            <LeftNavigation currentRouteName={currentRouteName} />
          </ErrorBoundary>
          <Routes>
            {/* Dashboard Component */}
            <Route
              exact
              path={routes.home.path}
              element={<routes.home.component />}
            />
            <Route
              exact
              path={routes.default.path}
              element={<routes.home.component />}
            />
            <Route
              exact
              path="/quote/list"
              element={<routes.home.component />}
            />
            {/* Details Component */}
            <Route
              exact
              path={routes.quoteDetails.path}
              element={<routes.quoteDetails.component />}
            />
            <Route
              exact
              path="/quote/details/:quoteId/customer/:customerId/user/:userId"
              element={<routes.quoteDetails.component />}
            />

            {/* Error Component */}
            <Route path="/error" element={<Error />} />
            <Route element={<Error />} />
          </Routes>
        </div>
      </div>
    </>
  );
};
